.card {
  &.root {
    box-shadow: none;
  }

  .header {
    min-height: unset;
    padding-top: var(--rc-theme-spacing-ms);
    border-bottom: 0;
  }

  &.card--margin-bottom {
    margin-bottom: var(--rc-theme-spacing-ms);
  }

  &.card--shrinked {
    .body {
      padding: 0;
    }

    .header {
      margin-bottom: 1px;
    }
  }

  &.card--shrinked-left {
    .body {
      padding-left: 0;
    }
  }

  &.card--shrinked-right {
    .body {
      padding-right: 0;
    }
  }

  &.card--shrinked-top {
    .body {
      padding-top: 0;
    }
  }

  &.card--shrinked-bottom {
    .body {
      padding-bottom: 0;
    }
  }

  &.card--full-height {
    height: 100%;

    .body {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }

  .card-full-width {
    width: calc(100% + 2 * var(--rc-theme-spacing-ms));
    margin-right: calc(-1 * var(--rc-theme-spacing-ms));
    margin-left: calc(-1 * var(--rc-theme-spacing-ms));
  }

  .card-horizontal-scroll {
    margin: 0 calc(-1 * var(--rc-theme-spacing-ms));
    /* TODO: Top padding is only for `outline` css for focus elements
     try find better solution to solve this */
    padding: var(--rc-theme-spacing-xxs) var(--rc-theme-spacing-ms);
    overflow-x: auto;
  }

  &:global(.ant-card-small) .card-horizontal-scroll {
    margin: 0 calc(-1 * var(--rc-theme-spacing-sm));
    /* TODO: Top padding is only for `outline` css for focus elements
     try find better solution to solve this */
    padding: var(--rc-theme-spacing-xxs) var(--rc-theme-spacing-sm);
  }
}
